import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom"; // Import useNavigate

interface RankingColumn {
  id: string;
  label: string;
}

interface RankingsProps {
  columns: RankingColumn[];
  data: any[];
}

const Rankings = ({ columns, data }: RankingsProps) => {
  const navigate = useNavigate(); // Initialize useNavigate

  const handleRowClick = (username: string) => {
    if (username) {
      navigate(`/${username}`); // Navigate to the profile page
    }
  };

  return (
    <TableContainer>
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        style={{ margin: "16px" }}
      >
        <Typography variant="h4" style={{ flexGrow: 1, textAlign: "center" }}>
          Top 10 Rankings:{" "}
          {new Date().toLocaleString("default", { month: "long" })}
        </Typography>
      </Box>
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((column) => (
              <TableCell key={column.id}>{column.label}</TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((ranking, index) => (
            <TableRow
              key={`${ranking.full_name}-${index}`}
              onClick={() => handleRowClick(ranking.user_username)}
            >
              {columns.map((column) => (
                <TableCell key={column.id}>
                  {column.id === "rank" ? index + 1 : ranking[column.id]}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default Rankings;
